/* QualifyCvesAction.js */

const QualifyCvesLauncher = require("../../../../lib/QualifyCvesLauncher");

class QualifyCvesAction {
    constructor(logger, modalUserFeedback, TriggerTypeEntity, userSession, activeView) {
        this._logger = logger;
        this._modalUserFeedback = modalUserFeedback;
        this._TriggerTypeEntity = TriggerTypeEntity;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._selectedDeviceIds = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (!this._selectedDeviceIds.length) {
            return this._modalUserFeedback
                .displayNotification("Select one or more devices to qualify CVE exposure.", {
                    title: "Qualify CVE Exposure",
                    confirmDetails: {
                        text: "OK",
                        type: "text",
                    },
                })
                .then(() => {
                    return this._modalUserFeedback.hideDisplayed();
                })
                .catch(() => {
                    return Promise.resolve();
                });
        }

        return QualifyCvesLauncher.launchQualifyCves({
            TriggerTypeEntity: this._TriggerTypeEntity,
            orgId: this._activeOrgId,
            workTarget: {
                method: "multi",
                category: "entity",
                entityType: "Device",
                ids: this._selectedDeviceIds,
            },
            modalUserFeedback: this._modalUserFeedback,
            logger: this._logger,
            sourceLabel: "the Devices grid",
        });
    }
}

module.exports = QualifyCvesAction;

QualifyCvesAction.$inject = [
    "$teve.logger",
    "$teve.ui.userFeedback",
    "$teve.entities.TriggerType",
    "$teve.userSession",
    "gameEditor.activeView",
];

QualifyCvesAction.$displayDetails = {
    type: "Action",
    name: "QualifyCvesAction",
    icon: "devicemanager.qualify_cves",
    shown: true,
    title: "Qualify CVE Exposure",
    // Sits immediately after Update Support Data (order 2), the other action that pulls
    // vendor advisory data — the two belong together in the toolbar. Fractional rather than
    // a tie at 2: the sort comparator returns 0 for equal orders, so a tie would leave the
    // side it lands on dependent on registration order in partRegistrations.js.
    order: 2.5,
};
